var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "address") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "where_to_vote_FILL1_wght400_GRAD0_opsz24",
    d: "M165.754-872.962l-.58-.58a.794.794,0,0,0-.58-.248.794.794,0,0,0-.58.248.806.806,0,0,0-.248.59.806.806,0,0,0,.248.59l1.159,1.18a.794.794,0,0,0,.58.248.794.794,0,0,0,.58-.248l2.939-2.939a.806.806,0,0,0,.248-.59.806.806,0,0,0-.248-.59.806.806,0,0,0-.59-.248.806.806,0,0,0-.59.248Zm7.493-.248a5.867,5.867,0,0,1-.362,1.956,10.892,10.892,0,0,1-1.056,2.132,17.948,17.948,0,0,1-1.728,2.287,32.38,32.38,0,0,1-2.38,2.422,1.524,1.524,0,0,1-.517.31,1.714,1.714,0,0,1-.58.1,1.714,1.714,0,0,1-.58-.1,1.524,1.524,0,0,1-.517-.31,32.38,32.38,0,0,1-2.38-2.422,17.951,17.951,0,0,1-1.728-2.287,10.892,10.892,0,0,1-1.056-2.132,5.866,5.866,0,0,1-.362-1.956,6.4,6.4,0,0,1,2-4.947A6.616,6.616,0,0,1,166.624-880a6.616,6.616,0,0,1,4.626,1.842A6.4,6.4,0,0,1,173.247-873.211Z",
    transform: "translate(1276.376 897)",
    fill: "#758091"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.91ac28fdc3469d4fb43720a6b090aacd.svg";
export { ForwardRef as ReactComponent };